import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createPinia } from 'pinia'
import apiPlugin from './plugins/api'
import bridgePlugin from './plugins/bridge'
import dayjsPlugin from './plugins/dayjs'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import './assets/scss/style.scss'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate) // 로컬스토리지 사용


createApp(App)
  .use(store)
  .use(router)
  .use(pinia)
  .use(apiPlugin)
  .use(bridgePlugin)
  .use(dayjsPlugin)
  .mount('#app')
